import "./plugins/axios";
import { createApp } from "vue";
import "./registerServiceWorker";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";
import VueRouterLayout from "vue-router-layout";
import imports from "./imports";
import "./responsa";

createApp(App)
  .use(router)
  // .use(createGtm(gtmConf))
  .use(VueRouterLayout)
  .use(store)
  .use(imports)
  .mount("#app");
